import { bootstrapMontageApp } from '@core/bootstrap';
import { TPortalType } from '@core/enums/portal-type.enum';

import { SYSTEM_APP } from './app/app';
import { AppComponent } from './app/app.component';

bootstrapMontageApp(AppComponent, SYSTEM_APP, TPortalType.System);
